/** Small header controller. All navigation links still work without JavaScript. */
(() => {
  'use strict';
  if (customElements.get('ir-header')) return;
  class IRHeader extends HTMLElement {
    connectedCallback() {
      if (!this.querySelector('[data-ir-menu]')) {
        this.readyFrame = requestAnimationFrame(() => {
          if (this.isConnected && this.querySelector('[data-ir-menu]')) this.connectedCallback();
        });
        return;
      }
      this.events?.abort();
      this.events = new AbortController();
      const opts = { signal: this.events.signal };
      this.menu = this.querySelector('[data-ir-menu]');
      this.menu?.addEventListener('toggle', () => this.updateMobileMenu(), opts);
      this.addEventListener('click', event => {
        if (event.target.closest('[data-ir-menu-close]')) this.closeMenu();
      }, opts);
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) {
          this.querySelectorAll('.ir-nav__item[open]').forEach(item => { item.open = false; });
        }
      }, opts);
      this.querySelectorAll('.ir-nav__item').forEach(item => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;
          this.querySelectorAll('.ir-nav__item[open]').forEach(other => { if (other !== item) other.open = false; });
        }, opts);
      });
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          if (this.menu?.open) { event.preventDefault(); this.closeMenu(); }
          this.querySelectorAll('.ir-nav__item[open]').forEach(item => {
            item.open = false; item.querySelector('summary')?.focus();
          });
        }
        if (event.key === 'Tab' && this.menu?.open) {
          const elements = [...this.menu.querySelectorAll('summary,a[href],button:not([disabled])')].filter(el => el.getClientRects().length);
          const first = elements[0], last = elements[elements.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
          if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
        }
      }, opts);
      window.addEventListener('resize', () => {
        if (window.matchMedia('(min-width: 990px)').matches && this.menu?.open) this.closeMenu(false);
      }, opts);
      const group = document.getElementById('header-group');
      if (group) group.dataset.irSticky = this.dataset.irSticky;
      const measure = () => {
        const height = Math.round(group?.getBoundingClientRect().height || this.offsetHeight);
        document.body.style.setProperty('--header-height', `${height}px`);
        document.body.style.setProperty('--header-group-height', `${height}px`);
        document.body.style.setProperty('--ir-header-height', `${height}px`);
      };
      this.observer = new ResizeObserver(measure);
      this.observer.observe(this);
      measure();
    }
    updateMobileMenu() {
      const panel = this.menu.querySelector('.ir-mobile-menu__panel');
      if (this.menu.open) {
        panel?.setAttribute('role', 'dialog');
        panel?.setAttribute('aria-modal', 'true');
        if (this.previousOverflow === undefined) this.previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this.menu.querySelector('summary')?.setAttribute('aria-expanded', 'true');
        this.menu.querySelector('[data-ir-menu-close]')?.focus();
      } else {
        panel?.removeAttribute('role');
        panel?.removeAttribute('aria-modal');
        this.unlock();
        this.menu.querySelector('summary')?.setAttribute('aria-expanded', 'false');
      }
    }
    unlock() {
      if (this.previousOverflow !== undefined) {
        document.body.style.overflow = this.previousOverflow;
        this.previousOverflow = undefined;
      }
    }
    closeMenu(focus = true) {
      if (!this.menu) return;
      this.menu.open = false;
      this.unlock();
      if (focus) this.menu.querySelector('summary')?.focus();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.readyFrame);
      this.observer?.disconnect(); this.events?.abort(); this.unlock();
    }
  }
  customElements.define('ir-header', IRHeader);
})();
